import {createAction} from '@reduxjs/toolkit'

export const resetPersistentLoadingState = createAction('RESET_PERSISTENT_LOADING_STATE')
